import { UserRoleEnum } from "../types/enums";

export const roleAccessMap: Record<string, UserRoleEnum[]> = {
  "/login": [UserRoleEnum.Admin, UserRoleEnum.Scanner],
  "/scanner": [UserRoleEnum.Admin, UserRoleEnum.Scanner],
  "/participants": [UserRoleEnum.Admin],
  "/organizations": [UserRoleEnum.Admin],
  "/event-configuration": [UserRoleEnum.Admin],
  "/news-configuration": [UserRoleEnum.Admin],
};
